import React, { useEffect, useState } from 'react';
import { Bold } from 'lucide-react';
import { PortalTooltip } from '@/components/ui/PortalTooltip';

export function GlobalFormatToolbar() {
  const [isActive, setIsActive] = useState(false);
  const [activeFormats, setActiveFormats] = useState({ bold: false });

  // Update button states based on selection
  useEffect(() => {
    const handleSelectionChange = () => {
      if (document.activeElement?.getAttribute('contenteditable') === 'true') {
        setIsActive(true);
        setActiveFormats({
          bold: document.queryCommandState('bold')
        });
      } else {
        setIsActive(false);
        setActiveFormats({ bold: false });
      }
    };

    document.addEventListener('selectionchange', handleSelectionChange);
    return () => document.removeEventListener('selectionchange', handleSelectionChange);
  }, []);

  const handleFormat = (command: string) => {
    document.execCommand(command, false, undefined);
  };

  return (
    <div className="sticky top-4 z-50 mx-auto w-max mb-4 bg-white dark:bg-slate-800 dark:shadow-lg border border-slate-200 dark:border-slate-700 rounded-full px-4 py-2 flex items-center gap-2 transition-opacity duration-200 opacity-100">
      <div className="text-xs font-semibold text-slate-500 dark:text-slate-400 mr-2 uppercase tracking-wider">Format</div>
      <PortalTooltip content="Bold (Ctrl+B / Cmd+B)" contentClassName="w-auto px-2 py-1 text-sm whitespace-nowrap">
        <button 
          onMouseDown={(e) => { e.preventDefault(); handleFormat('bold'); }}
          className={`p-1.5 rounded-md cursor-pointer transition-colors ${activeFormats.bold ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-400' : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700'}`}
        >
          <Bold className="w-4 h-4" />
        </button>
      </PortalTooltip>
    </div>
  );
}
